module.exports = __webpack_public_path__ + "img/colour_match_score.8194427d.jpg";